module.exports = __webpack_public_path__ + "019e72731504ac118ec6c8d13691fe34.png";